import { Counter } from '@/components/form/fields/number/Counter';
import { Product } from '@/services/api/contracts/catalog/types';
import {
  usePoSelectedProductQuantity,
  usePoSetProductQuantity
} from '@/services/purchaseOrders/usePurchaseOrderService';
import { FC } from 'react';

interface SelectedIndicatorProps {
  product: Product;
}

export const POSelectedProductIndicator: FC<SelectedIndicatorProps> = ({ product }) => {
  const setQuantity = usePoSetProductQuantity(product);
  const quantity = usePoSelectedProductQuantity(product);

  return (
    <div>
      <div className="bg-primary-700 text-white flex justify-center items-center py-1 font-semibold">
        <p>Selected</p>
      </div>
      <Counter
        className="flex justify-center py-2"
        id={product.id}
        value={quantity ?? 1}
        allowManualChange={true}
        min={1}
        onChange={(value: number) => setQuantity(value)}
      />
    </div>
  );
};
